import * as R from 'ramda';
import { httpGet, httpPut } from 'apiModule/rest';
import adapter from 'dataModule/adapter';
import { getIdsObject, getQueriesString } from 'utilsModule';

const retrieveDeviceRecordsByPatientId = async ({ params: { ids } }) =>
  R.pipe(
    getIdsObject,
    ({ patientId }) => httpGet(`deviceRecord/patients/${patientId}`),
    response => response.then(adapter.devices.retrieveDeviceRecordsByPatientId.be2fe),
  )(ids);

const retrieveDeviceRecordsByEpId = async ({ params: { ids, queries } }) => {
  const url = R.pipe(
    getIdsObject,
    ({ patientId }) => `deviceRecord/patients/${patientId}`,
  )(ids);

  return R.pipe(
    getQueriesString,
    queriesString => httpGet(`${url}${queriesString}`),
    response => response.then(adapter.devices.retrieveDeviceRecordsByPatientId.be2fe),
  )(queries);
};

const createReturnOrReplaceDeviceRecord = async ({ content, params: { ids } }) => {
  const url = R.pipe(
    getIdsObject,
    ({ patientId }) => `patients/${patientId}/replace-or-return`,
  )(ids);

  return R.pipe(
    adapter.devices.createReturnOrReplaceDeviceRecord.fe2be,
    httpPut(url),
    response => response.then(adapter.devices.createReturnOrReplaceDeviceRecord.be2fe),
  )(content);
};

const DM = {
  retrieveDeviceRecordsByPatientId,
  retrieveDeviceRecordsByEpId,
  createReturnOrReplaceDeviceRecord,
};

const ajax = async ({ method, input }) => ({ [method]: await DM[method](input) });

export default { ...DM, ajax };
